import { Injectable } from '@angular/core';
import {AngularFireStorage} from '@angular/fire/storage';
import {SessionService} from './session.service';
import {CommonService} from './common.service';
import {DomSanitizer} from '@angular/platform-browser';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CloudStorageService {
  constructor(private storage: AngularFireStorage,
              private sessionService: SessionService,
              private commonService: CommonService,
              private sanitizer: DomSanitizer) { }

  /**
   *
   * @param uploadFileList
   */
  uploadAllFile(uploadFileList:any) {
    return new Promise<any>((resolve, reject) => {
      const promiseArray: any = [];
      if (uploadFileList && uploadFileList.length > 0) {
        console.log('00001 uploadFileList: ', uploadFileList);
        uploadFileList.forEach((uploadFile: any) => {
          promiseArray.push(this.storage.upload(uploadFile.path, uploadFile.fileData)
            .then(val => console.log('00002 upload succseed', val))
            .catch(e => {
              console.log('task: ', e);
              reject(e);
            }));
        });
      } else {
        return resolve('ok');
      }
      Promise.all(promiseArray).then(() => {
        console.log('00003 uploadAllFile Promise.all then');
        resolve('ok');
      }).catch(e => {
        console.log('uploadAllFile Promise.all: ', e);
        reject(e);
      });
    });
  }

  /**
   *
   * @param deleteFileList
   */
  deleteAllFile(deleteFileList: any[]) {
    return new Promise<any>((resolve, reject) => {
      const promiseArray: any = [];
      if (deleteFileList && deleteFileList.length > 0) {
        console.log('00011 deleteFileList: ', deleteFileList);
        deleteFileList.forEach(deleteFile => {
          promiseArray.push(this.deleteFile(deleteFile));
        });
      } else {
        return resolve('ok');
      }
      Promise.all(promiseArray).then(() => {
        console.log('00015 deleteAllFile Promise.all then');
        resolve('ok');
      }).catch(e => {
        console.log('deleteAllFile Promise.all: ', e);
        reject(e);
      });
    });
  }

  /**
   *
   * @param path
   */
  async downLoad(path: string) {
    const downloadURL = await this.getDownloadURLByPath(path);
    console.log(downloadURL);
    const res = await fetch(downloadURL);
    const blobURL = await this.genBlobURL(res);
    return blobURL;
  }

  /**
   *
   * @param path
   */
  getDownloadURLByPath(path: string) {
    const ref = this.storage.ref(path);
    console.log(ref);
    return firstValueFrom(ref.getDownloadURL());
  }

  /**
   *
   * @param file
   */
  async genBlobURL(file: any) {
    // Blob形式でデータ取得.
    const blob = await file.blob();
    const blobURL = window.URL.createObjectURL(blob);
    return blobURL;
  }

  /**
   *
   * @param fileName
   * @param blobURL
   */
  async forceDownLoadToLocal(fileName: string, blobURL: any) {
    // https://qiita.com/k5690033/items/dd1d5fe3067535120d1c
    const link = document.createElement('a');
    link.download = fileName;
    link.href = blobURL;
    link.click();
    window.URL.revokeObjectURL(blobURL);
  }

  /**
   *
   * @param path
   */
  deleteFile(path: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const downloadURL = this.getDownloadURLByPath(path);
      console.log('00012 deleteFile: ', downloadURL);
      downloadURL.then(value => {
        console.log('00013 downloadURL: ', downloadURL);
        // https://stackoverflow.com/a/64455916
        this.storage.storage.refFromURL(value).delete().then(() => {
          console.log('00014 refFromURL delete');
          resolve('ok');
        }).catch(e => {
          console.log('refFromURL(value).delete error: ', e);
          reject(e);
        });
      }).catch(e => {
        console.log('downloadURL error: ', e);
        reject(e);
      });
    });
  }

  /**
   *
   * @param file
   */
  fileToArrayBuffer(file: File): Promise<any> {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve, reject) => {
      reader.onload = () => {
        resolve(this.sanitizeUrl(reader.result));
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    });
  }

  /**
   *
   * @param blobURL
   */
  sanitizeUrl(blobURL: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(blobURL);
  }
}
